const MuiSkeleton = {
  defaultProps: {
    animation: 'wave',
  },
}

export default MuiSkeleton
